class ReciteMe {
  private readonly reciteElements: NodeListOf<Element>

  constructor () {
    this.reciteElements = document.querySelectorAll('.js-button-a11y-tools')

    if (this.reciteElements.length === 0) return

    this.bindEventListeners()
  }

  private bindEventListeners (): void {
    this.reciteElements.forEach((element) => {
      element.addEventListener(
        'click',
        (e) => {
          e.preventDefault()
          loadService()
        },
        true
      )
    })
  }
}

export default ReciteMe
